// Campus photo for /colleges/marquette-university: CC BY-SA 3.0, by © Matthew Hendricks, from
// Wikimedia Commons (https://commons.wikimedia.org/wiki/File%3AJohnston_Hall_(Marquette_University).jpg), checked 2026-10-02 by
// scripts/college-photo.mjs (license allowlist, no restrictions, not a logo).
// Resized and self-hosted under public/colleges/marquette-university/; credited under the photo.
const photo = {
    "slug": "marquette-university",
    "alt": "Johnston Hall, its walls covered in ivy, on the Marquette University campus in Milwaukee, Wisconsin",
    "src": "/colleges/marquette-university/campus-1600.webp",
    "srcSmall": "/colleges/marquette-university/campus-800.webp",
    "srcMid": "/colleges/marquette-university/campus-1200.webp",
    "width": 1600,
    "height": 900,
    "og": "/colleges/marquette-university/og.jpg",
    "title": "Johnston Hall (Marquette University)",
    "author": "© Matthew Hendricks",
    "license": "CC BY-SA 3.0",
    "licenseUrl": "https://creativecommons.org/licenses/by-sa/3.0",
    "sourceUrl": "https://commons.wikimedia.org/wiki/File%3AJohnston_Hall_(Marquette_University).jpg",
    "read": "2026-10-02"
};

export default photo;
